/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table, Form, Button, Grid, Popup, Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { read, write } from "xlsx";
import { logAction } from "../actions/changeActiveItemActions";
import DevicesStatistics from "./DevicesStatistics";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

// Regex to match agains the form input to know if the user typed an IP or a device name
const ipRegex = new RegExp("^[0-2][0-9.]*$");
const nameRegex = new RegExp("^[A-Za-z][A-Za-z-]*");
const macRegex = new RegExp("^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$");

const UtilsInstance = new Utils();

class Inventory extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,

      sortDirection: "ascending",
      originalDevices: [],
      devices: [],

      isColumnClicked: false,
    };
  }

  // Sorts the table when the user clicks on one of the columns
  handleSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    // The user wants to order the live list by name ascending
    if (clickedColumn === "name" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "name",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by name descending
    else if (clickedColumn === "name" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "name",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by ip ascending
    else if (clickedColumn === "ip" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        }),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by ip descending
    else if (clickedColumn === "ip" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.reverse(),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by role ascending
    else if (clickedColumn === "role" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "role",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by role descending
    else if (clickedColumn === "role" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "role",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by model ascending
    else if (clickedColumn === "model" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "model",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by model descending
    else if (clickedColumn === "model" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "model",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by manufacturer ascending
    else if (clickedColumn === "manufacturer" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "manufacturer",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by manufacturer descending
    else if (clickedColumn === "manufacturer" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "manufacturer",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by orderNumber ascending
    else if (clickedColumn === "orderNumber" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "orderNumber",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by orderNumber descending
    else if (clickedColumn === "orderNumber" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "orderNumber",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by hardwareVersion ascending
    else if (clickedColumn === "hardwareVersion" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "hardwareVersion",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by hardwareVersion descending
    else if (clickedColumn === "hardwareVersion" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "hardwareVersion",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by firmwareVersion ascending
    else if (clickedColumn === "firmwareVersion" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "firmwareVersion",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by firmwareVersion descending
    else if (clickedColumn === "firmwareVersion" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "firmwareVersion",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
  }

  handleIPSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];
    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].ip === this.state.formInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  // Creates a list with entries that match the name passed on the form
  handleNameAndModelSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      // Also remove all whitespaces in both strings before comparing
      if (this.state.originalDevices[i].name != null && this.state.formInput != null) {

        let noWhitespaceUppercasedDeviceName = this.state.originalDevices[i].name.toUpperCase().replace(/\s/g, "");
        let noWhitespaceUppercasedDeviceModel = this.state.originalDevices[i].model.toUpperCase().replace(/\s/g, "");
        let noWhitespaceUppercasedFormInput = this.state.formInput.toUpperCase().replace(/\s/g, "");

        if (noWhitespaceUppercasedDeviceName.indexOf(noWhitespaceUppercasedFormInput) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
        else if (noWhitespaceUppercasedDeviceModel.indexOf(noWhitespaceUppercasedFormInput) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleMacAddressSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].mac != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].mac.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    Filters the page list showing only the devices that match the
    ip, name, model or mac the user has typed in the form
  */
  handleSubmit = () => {
    if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
      this.handleIPSearch();
    }
    else if (this.state.formInput !== "" && macRegex.test(this.state.formInput)) {
      this.handleMacAddressSearch();
    }
    else if (this.state.formInput !== "" && nameRegex.test(this.state.formInput)) {
      this.handleNameAndModelSearch();
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user
    // didn't sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {
      let promissesArray = [];

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "inventory", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      let livelist = resolvedPromisses[0].sort((a, b) => {
        const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        return num1 - num2;
      });

      let inventory = resolvedPromisses[1].sort((a, b) => {
        const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        return num1 - num2;
      });

      this.addRoleToInventory(inventory, livelist);

      this.setState({
        devices: inventory,
        originalDevices: inventory
      });
    }
  }

  addRoleToInventory = (inventory, livelist) => {
    for (let i = 0; i < inventory.length; i++) {
      for (let j = 0; j < livelist.length; j++) {
        if (inventory[i].mac === livelist[j].mac) {
          inventory[i].role = livelist[j].role;
          break;
        }
      }
    }
  }

  getIoControllerCell = (ioControllerList) => {
    if (ioControllerList != null && ioControllerList.length > 0) {
      return (
        <Table.Cell verticalAlign="middle">
          {ioControllerList.map(ioController => {
            if (ioController != null) {
              return <> {UtilsInstance.addWhitespaceToLongStrings(ioController, false)} <br /> </>;
            }
            else {
              return Strings.NO_IO_CONTROLLER;
            }
          })}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell verticalAlign="middle">
          {Strings.NO_IO_CONTROLLER}
        </Table.Cell>
      );
    }
  }

  getHardwareVersionString = () => {
    let langKey = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    if (langKey === Constants.ES_LANG_KEY) {
      return <>{Strings.VERSION_OF}<br />Hardware</>;
    }
    else if (langKey === Constants.EN_LANG_KEY) {
      return <>Hardware<br />{Strings.VERSION_OF}</>;
    }
    else {
      return <>{Strings.VERSION_OF}<br />Hardware</>;
    }
  }

  getFirmwareVersionString = () => {
    let langKey = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    if (langKey === Constants.ES_LANG_KEY) {
      return <>{Strings.VERSION_OF}<br />Firmware</>;
    }
    else if (langKey === Constants.EN_LANG_KEY) {
      return <>Firmware<br />{Strings.VERSION_OF}</>;
    }
    else {
      return <>{Strings.VERSION_OF}<br />Firmware</>;
    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * 0.7;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  exportInventoryAsCSV = () => {
    let csvText = Strings.INVENTORY_CSV_HEADER;

    for (let i = 0; i < this.state.originalDevices.length; i++) {

      let name = this.state.originalDevices[i].name;
      let role = this.state.originalDevices[i].role;
      let model = this.state.originalDevices[i].model;
      let manufacturer = this.state.originalDevices[i].manufacturer;
      let orderNumber = this.state.originalDevices[i].orderNumber;
      let hardwareVersion = this.state.originalDevices[i].hardwareVersion;
      let firmwareVersion = this.state.originalDevices[i].firmwareVersion;

      name = (name != null) ? name.replace(/,/g, "") : "";
      role = (role != null) ? role.replace(/,/g, "") : "";
      model = (model != null) ? model.replace(/,/g, "") : "";
      manufacturer = (manufacturer != null) ? manufacturer.replace(/,/g, "") : "";
      orderNumber = (orderNumber != null) ? orderNumber : "";
      hardwareVersion = (hardwareVersion != null) ? hardwareVersion : "";
      firmwareVersion = (firmwareVersion != null) ? firmwareVersion : "";

      csvText += name + ","
        + this.state.originalDevices[i].mac + ","
        + this.state.originalDevices[i].ip + ","
        + role + ","
        + model + ","
        + manufacturer + ","
        + orderNumber + ","
        + hardwareVersion + ","
        + firmwareVersion + ",";

      if (this.state.originalDevices[i].ioControllerList.length === 0) {
        csvText += Strings.NO_IO_CONTROLLER + "\n";
      }
      else {
        for (let j = 0; j < this.state.originalDevices[i].ioControllerList.length; j++) {
          if (j === (this.state.originalDevices[i].ioControllerList.length - 1)) {
            if (this.state.originalDevices[i].ioControllerList[j] !== null) {
              csvText += this.state.originalDevices[i].ioControllerList[j].replace(/,/g, "") + "\n";
            }
            else {
              csvText += Strings.NO_IO_CONTROLLER + "\n";
            }
          }
          else {
            if (this.state.originalDevices[i].ioControllerList[j] !== null) {
              csvText += this.state.originalDevices[i].ioControllerList[j].replace(/,/g, "") + " / ";
            }
          }
        }

      }
    }

    const workbook = read(csvText, { type: "string", raw: true });
    /* Aqui convertemos o workbook para o formato .xlsx */
    const wbout = write(workbook, { bookType: "xlsx", type: "binary" });

    /* Criação do blob e link para download */
    const blob = new Blob([UtilsInstance.s2ab(wbout)], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = Strings.INVENTORY_EXPORT_NAME;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  // Render the table containing all network devices
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      <Table.Row key={device.id}>
        <Table.Cell verticalAlign="middle">{UtilsInstance.addWhitespaceToLongStrings(device.name, false)}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{device.mac}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.ip}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.role}</Table.Cell>
        <Table.Cell verticalAlign="middle">{UtilsInstance.addWhitespaceToLongStrings(device.model, true)}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.manufacturer}</Table.Cell>
        <Table.Cell verticalAlign="middle">{UtilsInstance.addWhitespaceToLongStrings(device.orderNumber, false)}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.hardwareVersion}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.firmwareVersion}</Table.Cell>
        {this.getIoControllerCell(device.ioControllerList)}
      </Table.Row>
    ));

    return (
      <div style={screenStyle}>

        <Grid className="ts-page-toolbar ts-inventory-toolbar" columns={3} textAlign="center" verticalAlign="middle" doubling stackable>
          <Grid.Row>
            <Grid.Column>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>

                <DevicesStatistics />
              </div>
            </Grid.Column>

            <Grid.Column>
              <Form className="ts-toolbar-search" style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.INVENTORY_INPUT_TEXT_PLACEHOLDER}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Button
                floated="right"
                style={{ marginRight: "0.5vw" }}
                content={Strings.EXPORT_CSV}
                color="teal"
                onClick={this.exportInventoryAsCSV} />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Table id="table-header" style={headerMarginStyle} sortable striped celled fixed singleLine selectable textAlign="center">
          <Table.Header>
            <Table.Row>

              <Table.HeaderCell
                sorted={column === "name" ? direction : null}
                onClick={this.handleSort("name")}>
                {Strings.NAME}
              </Table.HeaderCell>

              <Table.HeaderCell width={2} disabled>
                {Strings.MAC}
              </Table.HeaderCell>

              <Table.HeaderCell
                sorted={column === "ip" ? direction : null}
                onClick={this.handleSort("ip")}>
                {Strings.IP}
              </Table.HeaderCell>

              <Table.HeaderCell
                sorted={column === "role" ? direction : null}
                onClick={this.handleSort("role")}>
                {Strings.FUNCTION}
              </Table.HeaderCell>

              <Table.HeaderCell
                sorted={column === "model" ? direction : null}
                onClick={this.handleSort("model")}>
                {Strings.MODEL}
              </Table.HeaderCell>

              <Table.HeaderCell
                sorted={column === "manufacturer" ? direction : null}
                onClick={this.handleSort("manufacturer")}>
                {Strings.MANUFACTURER}
              </Table.HeaderCell>

              <Table.HeaderCell
                sorted={column === "orderNumber" ? direction : null}
                onClick={this.handleSort("orderNumber")}>
                {Strings.ORDER_NUMBER}
              </Table.HeaderCell>

              <Table.HeaderCell
                sorted={column === "hardwareVersion" ? direction : null}
                onClick={this.handleSort("hardwareVersion")}>
                {this.getHardwareVersionString()}
              </Table.HeaderCell>

              <Table.HeaderCell
                sorted={column === "firmwareVersion" ? direction : null}
                onClick={this.handleSort("firmwareVersion")}>
                {this.getFirmwareVersionString()}
              </Table.HeaderCell>

              <Popup position='left center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell disabled>
                    {Strings.IO_CONTROLLER}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /> <br />
                    {Strings.ASSOCIATED}
                  </Table.HeaderCell>}>
                <Popup.Content>
                  <p>{Strings.IO_CONTROLLER_POPUP_1}</p>
                  <p>{Strings.IO_CONTROLLER_POPUP_2}</p>
                  <ul>
                    <li>{Strings.IO_CONTROLLER_POPUP_3}</li>
                    <li>{Strings.IO_CONTROLLER_POPUP_4}</li>
                    <li>{Strings.IO_CONTROLLER_POPUP_5}</li>
                  </ul>
                </Popup.Content>
              </Popup >

            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" className="ts-inventory-table" sortable celled fixed textAlign="center">
            <Table.Body>{devices}</Table.Body>
          </Table>

        </div>
      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  marginTop: "8px",
  marginLeft: "4px",
  marginRight: "4px",
  marginBottom: "8px",
};

const tableStyle = {
  overflowY: "scroll"
};

const headerMarginStyle = {
  marginTop: "0px",
  marginBottom: "8px",
  width: "99.5%"
};

const searchStyle = {
  margin: "0 auto",
  marginTop: "8px",
  marginBottom: "16px"
};

const mapActionsToProps = {
  onChangeLog: logAction
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default connect(null, mapActionsToProps)(withRouter(Inventory));